import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LOGIN_ROUTE } from '../constants/constants';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard {
  public url: any;
  constructor(
    public router: Router,
    private storageService: StorageService
  ) {}
  ngOnInit() {
    this.url = this.router.url;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Guard for user is login or not
    let user = this.storageService.getFromLocalOrSessionStorage('user');
    if (!user || user === null) {
      this.router.navigate([LOGIN_ROUTE]);
      return true;
    } else if (user) {
      if (!Object.keys(user).length) {
        this.router.navigate([LOGIN_ROUTE]);
        return true;
      }
    }
    return true;
  }
}
